import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-bone px-5 py-16 sm:py-24" data-id="element-107" data-mp="1o2vfqkp72f4g">
      <Reveal className="mx-auto max-w-4xl" data-id="element-108" data-mp="223685s65k1rq">
        <div className="flex flex-col items-start gap-7 rounded-3xl border-2 border-ink bg-volt p-8 sm:flex-row sm:p-11" data-id="element-109" data-mp="222whs3h73sli">
          <span className="inline-flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl border-2 border-ink bg-ink text-volt" data-id="element-110" data-mp="1x28qdgp219qr">
            <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-111" data-mp="14g64m3h4so7s" />
          </span>
          <div data-id="element-112" data-mp="1j4agooloi1hl">
            <h2 className="font-display text-2xl leading-tight text-ink sm:text-3xl" data-id="element-113" data-mp="1j4tz06f8qrw5">
              Garantía «Docente Sin Estrés» de 7 días
            </h2>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-ink/80" data-id="element-114" data-mp="1ebr5tzedlkgh">
              Prueba el material por 7 días. Si sientes que no te hace ahorrar
              horas de trabajo o no satisface tus estándares profesionales, te
              devolvemos cada centavo. Sin preguntas. El riesgo es todo
              nuestro.
            </p>
            <a href="#faq" className="mt-5 inline-block text-sm font-bold text-ink underline underline-offset-4 transition-colors duration-150 ease-out hover:text-brand-dark" data-id="element-115" data-mp="txku73tfb803">
              Ver las preguntas frecuentes
            </a>
          </div>
        </div>
      </Reveal>
    </section>;
}